import React from "react";
import { Heart } from "lucide-react";
import { useWishlist } from "../../context/WishlistContext";

const WishlistButton = ({
  product,
  color = "",
  size = "",
  beforeToggle,
  className = "",
  label = "",
  variant = "default",
}) => {
  const wishlist = useWishlist();
  if (!product || !wishlist) return null;

  const active = wishlist.isInWishlist(product.id, color, size);
  const key = `${String(product.id || "").trim()}::${String(color || "").trim().toLowerCase()}::${String(size || "").trim().toLowerCase()}`;
  const pending = !!wishlist.pendingKeys[key];

  const handleClick = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (pending) return;
    if (!active && beforeToggle && beforeToggle() === false) return;
    await wishlist.toggleItem(product, color, size);
  };

  const variantClass = variant === "red"
    ? "border-cynos-red bg-cynos-red text-white hover:border-red-600 hover:bg-red-600 hover:text-white"
    : "border-white/15 bg-black/70 text-white hover:border-cynos-red hover:text-cynos-red";

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={pending}
      aria-pressed={active}
      aria-label={active ? "Remove from wishlist" : "Add to wishlist"}
      className={`inline-flex items-center justify-center gap-2 border backdrop-blur transition disabled:opacity-60 ${variantClass} ${active && variant !== "red" ? "border-cynos-red text-cynos-red" : ""} ${className}`}
      data-testid={`wishlist-btn-${product.slug || product.id}`}
    >
      <Heart size={18} fill={active ? "currentColor" : "none"} className={pending ? "animate-pulse" : "transition-transform duration-200 group-hover:scale-110"} />
      {label && <span className="font-mono text-xs uppercase tracking-[0.2em]">{label}</span>}
    </button>
  );
};

export default WishlistButton;
